export default {"src":"/_next/static/media/beneficieryUser.e539a1ac.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};